import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from '@mui/material/FormControlLabel';

import {ReactComponent as SwitchOff} from "assets/img/switch_off.svg";
import {ReactComponent as SwitchOn} from "assets/img/switch_on.svg";
import {grey500} from "../../assets/jss/main";

CustomSwitch.propTypes = {
    checked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string
};

CustomSwitch.defaultProps = {
    checked: false,
    onClick: () => {},
    label: null
}

function CustomSwitch({checked, onClick, label, disabled, ...props}) {
    const switchComponent = (
        <Checkbox
            icon={<SwitchOff />}
            checkedIcon={<SwitchOn />}
            checked={checked}
            onClick={onClick}
            disabled={disabled}
            inputProps={{ 'aria-label': 'primary checkbox' }}
            sx={{
                '&.MuiCheckbox-root': {
                    cursor: 'pointer',
                    padding: 0,
                    marginRight: '8px'
                },
                '&.Mui-disabled svg rect': { // toggle is an svg
                    fill: grey500,
                }
            }}
            {...props}
        />
    )

    if (label) {
        return (
            <FormControlLabel
                label={label}
                control={switchComponent}
                sx={{
                    '&.MuiFormControlLabel-root': {
                        marginLeft: 0
                    },
                    '.MuiFormControlLabel-label': {
                        fontSize: '14px'
                    }
                }}
            />
        )
    }

    return switchComponent
}

export default CustomSwitch;
